(() => {
  const sections = document.querySelectorAll(".sticker-customizer-section");
  if (!sections.length) return;

  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const workerUrl = section.dataset.workerUrl || "";

    const canvas = document.getElementById(`StickerCanvas-${sectionId}`);
    const layerList = document.getElementById(`StickerLayerList-${sectionId}`);
    const photoInput = document.getElementById(`StickerPhotoInput-${sectionId}`);
    const textInput = document.getElementById(`StickerTextInput-${sectionId}`);
    const textAdd = document.getElementById(`StickerTextAdd-${sectionId}`);
    const textIdea = document.getElementById(`StickerTextIdea-${sectionId}`);
    const previewButton = document.getElementById(`StickerPreviewButton-${sectionId}`);
    const previewModal = document.getElementById(`StickerPreviewModal-${sectionId}`);
    const previewClose = document.getElementById(`StickerPreviewClose-${sectionId}`);
    const previewContainer = document.getElementById(`StickerPreviewContainer-${sectionId}`);
    const summaryLayers = document.getElementById(`StickerSummaryLayers-${sectionId}`);
    const variantPicker = document.getElementById(`StickerVariantPicker-${sectionId}`);
    const previewUrlInput = document.getElementById(`StickerPreviewUrl-${sectionId}`);
    const jsonUrlInput = document.getElementById(`StickerJsonUrl-${sectionId}`);
    const layerCountInput = document.getElementById(`StickerLayerCountInput-${sectionId}`);
    const designStateInput = document.getElementById(`StickerDesignState-${sectionId}`);
    const submitButton = document.getElementById(`StickerSubmitButton-${sectionId}`);
    const validation = document.getElementById(`StickerValidationMessage-${sectionId}`);
    const form = submitButton?.closest("form");
    const demoButton = document.getElementById(`StickerDemoButton-${sectionId}`);
    const demoOverlay = document.getElementById(`StickerDemoOverlay-${sectionId}`);
    const instructions = document.querySelectorAll(".sticker-instructions-list li");

    if (!canvas || !layerList || !photoInput || !textInput || !textAdd || !variantPicker || !form) return;

    const layers = [];
    let selectedLayerId = null;
    let isUploading = false;
    let activeColorPickerLayerId = null;

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    const uid = () => `layer-${Date.now()}-${Math.floor(Math.random() * 99999)}`;
    const nextZ = () => !layers.length ? 1 : Math.max(...layers.map((l) => l.zIndex)) + 1;
    const sanitize = (v) => String(v || "").replace(/[<>]/g, "");
    const sortByZ = () => layers.sort((a, b) => a.zIndex - b.zIndex);

    // ── INSTRUCTIONS HIGHLIGHT ──
    instructions.forEach(item => {
      item.addEventListener("click", () => {
        const step = item.dataset.step;
        let target = null;
        if (step === "1") target = document.querySelector(".sticker-customizer__upload");
        if (step === "2") target = canvas;
        if (step === "3") target = document.querySelector(".sticker-customizer__inline");
        if (step === "4") target = variantPicker;
        if (step === "5") target = previewButton;
        if (step === "6") target = document.querySelector(".sticker-summary");
        
        if (target) {
          target.classList.remove("ui-highlight");
          void target.offsetWidth; // trigger reflow
          target.classList.add("ui-highlight");
          target.scrollIntoView({ behavior: "smooth", block: "center" });
          setTimeout(() => target.classList.remove("ui-highlight"), 1500);
        }
      });
    });


    // ── UPLOAD STATUS UI ──
    let statusEl = null;
    const showUploadStatus = (msg) => {
      if (!statusEl) {
        statusEl = document.createElement("div");
        statusEl.style.cssText =
          "position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#111;color:#C9A84C;padding:10px 22px;border-radius:8px;font-size:13px;font-weight:600;z-index:9999;letter-spacing:0.5px;box-shadow:0 4px 20px rgba(0,0,0,0.4);";
        document.body.appendChild(statusEl);
      }
      statusEl.textContent = msg;
      statusEl.style.display = "block";
    };
    const hideUploadStatus = () => {
      if (statusEl) statusEl.style.display = "none";
    };

    const processImage = async (file) => {
      const workerConfigured = workerUrl && workerUrl !== "" && workerUrl !== "https://your-worker.workers.dev";
      if (!workerConfigured) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(file);
        });
      }
      try {
        showUploadStatus("Uploading image...");
        const formData = new FormData();
        formData.append("image", file);
        showUploadStatus("Removing background...");
        const res = await fetch(workerUrl, { method: "POST", body: formData });
        if (!res.ok) throw new Error("Worker request failed: " + res.status);
        const json = await res.json();
        if (!json.success) throw new Error(json.error || "Worker returned an error");
        const byteChars = atob(json.image);
        const byteArray = new Uint8Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) byteArray[i] = byteChars.charCodeAt(i);
        const blob = new Blob([byteArray], { type: json.contentType || "image/png" });
        hideUploadStatus();
        return URL.createObjectURL(blob);
      } catch (err) {
        console.warn("Background removal failed, using original image:", err.message);
        hideUploadStatus();
        showUploadStatus("⚠ BG removal failed — using original");
        setTimeout(hideUploadStatus, 3000);
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(file);
        });
      }
    };

    const updateFormState = () => {
      const hasContent = layers.length > 0 && !isUploading;
      const checkedInputs = Array.from(variantPicker.querySelectorAll("input[type='checkbox']:checked"));
      
      submitButton.disabled = !hasContent || checkedInputs.length === 0;
      if (previewButton) previewButton.disabled = !hasContent || checkedInputs.length === 0;
      layerCountInput.value = String(layers.length);
      summaryLayers.textContent = `${layers.length} layer${layers.length === 1 ? "" : "s"}`;
      
      const productsContainer = document.getElementById(`StickerSummaryProducts-${sectionId}`);
      const summaryPriceEl = document.getElementById(`StickerSummaryPrice-${sectionId}`);
      if (productsContainer) {
        productsContainer.innerHTML = "";
        let total = 0;
        checkedInputs.forEach(input => {
          total += Number(input.dataset.price);
          productsContainer.innerHTML += `
            <div class="sticker-summary-item">
              <span>${input.dataset.title}</span>
              <span>${input.dataset.priceMoney}</span>
            </div>
          `;
        });
        if (summaryPriceEl) summaryPriceEl.textContent = "$" + (total/100).toFixed(2);
      }

      designStateInput.value = JSON.stringify(
        layers.map((layer) => ({
          id: layer.id,
          type: layer.type,
          x: layer.x,
          y: layer.y,
          zIndex: layer.zIndex,
          text: layer.type === "text" ? layer.text : undefined,
          src: layer.type === "image" && layer.src && layer.src.startsWith("http") ? layer.src : undefined,
        }))
      );
      if (validation) validation.hidden = hasContent;
    };

    const closeAllColorPickers = () => {
      document.querySelectorAll('.sticker-color-palette-popup').forEach(el => el.remove());
      activeColorPickerLayerId = null;
    };

    document.addEventListener("click", (e) => {
      if (!e.target.closest('.sticker-layer-color-btn') && !e.target.closest('.sticker-color-palette-popup')) {
        closeAllColorPickers();
      }
    });
    window.addEventListener("resize", closeAllColorPickers);
    layerList.addEventListener("scroll", closeAllColorPickers);

    const renderLayerList = () => {
      layerList.innerHTML = "";
      sortByZ();
      layers.slice().reverse().forEach((layer) => {
        const item = document.createElement("li");
        item.draggable = true;
        item.dataset.id = layer.id;
        const isText = layer.type === "text";
        const inner = isText
            ? `<div class="text-preview" style="color:${layer.color || "#000"}">${sanitize(layer.text)}</div>`
            : `<img src="${layer.src}" alt="" draggable="false">`;
        
        item.innerHTML = `
          <div class="sticker-layer-item-content">${inner}</div>
          <div class="sticker-layer-controls">
            <button type="button" data-action="delete" data-id="${layer.id}">✕</button>
          </div>
          ${isText ? `<div class="sticker-layer-color-btn" style="background:${layer.color || '#000'}" data-id="${layer.id}"></div>` : ''}
        `;
        layerList.appendChild(item);
      });
    };

    let draggedLayerId = null;
    layerList.addEventListener("dragstart", (e) => {
      const li = e.target.closest("li");
      if (!li) return;
      draggedLayerId = li.dataset.id;
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", draggedLayerId);
      closeAllColorPickers();
    });
    layerList.addEventListener("dragenter", (e) => e.preventDefault());
    layerList.addEventListener("dragover", (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      const targetLi = e.target.closest("li");
      if (targetLi && targetLi.dataset.id !== draggedLayerId) {
        const rect = targetLi.getBoundingClientRect();
        const mid = rect.left + rect.width / 2;
        layerList.querySelectorAll("li").forEach((l) => l.classList.remove("drag-over-left", "drag-over-right"));
        targetLi.classList.add(e.clientX < mid ? "drag-over-left" : "drag-over-right");
      }
    });
    layerList.addEventListener("dragleave", (e) => {
      const targetLi = e.target.closest("li");
      if (targetLi) targetLi.classList.remove("drag-over-left", "drag-over-right");
    });
    layerList.addEventListener("drop", (e) => {
      e.preventDefault();
      layerList.querySelectorAll("li").forEach((l) => l.classList.remove("drag-over-left", "drag-over-right"));
      const targetLi = e.target.closest("li");
      if (!targetLi || !draggedLayerId || targetLi.dataset.id === draggedLayerId) return;
      const rect = targetLi.getBoundingClientRect();
      const mid = rect.left + rect.width / 2;
      const draggedEl = document.querySelector(`li[data-id="${draggedLayerId}"]`);
      if (e.clientX < mid) targetLi.before(draggedEl);
      else targetLi.after(draggedEl);
      Array.from(layerList.querySelectorAll("li")).map((li) => li.dataset.id).reverse().forEach((id, idx) => {
        const layer = layers.find((l) => l.id === id);
        if (layer) layer.zIndex = idx + 1;
      });
      rerender();
    });

    const updateCanvasRatio = () => {
      const checkedInputs = Array.from(variantPicker.querySelectorAll("input[type='checkbox']:checked"));
      if (!checkedInputs.length) return;
      const lastSelectedTitle = checkedInputs[checkedInputs.length - 1].dataset.title.toLowerCase();
      
      let ratio = 4 / 5; // default
      if (lastSelectedTitle.includes("mirror") || lastSelectedTitle.includes("tag")) {
        ratio = 3.5 / 5;
      } else if (lastSelectedTitle.includes("small") || lastSelectedTitle.includes("large") || lastSelectedTitle.includes("8x10") || lastSelectedTitle.includes("16x20") || lastSelectedTitle.includes("4:5")) {
        ratio = 4 / 5;
      } else if (lastSelectedTitle.includes("medium") || lastSelectedTitle.includes("11x14")) {
        ratio = 11 / 14;
      }

      const canvasW = canvas.offsetWidth;
      canvas.style.height = `${canvasW / ratio}px`;
    };

    const renderCanvas = () => {
      canvas.innerHTML = "";
      sortByZ();
      layers.forEach((layer) => {
        const wrapper = document.createElement("div");
        wrapper.className = `sticker-canvas-item-wrapper sticker-canvas-item--${layer.type}`;
        wrapper.dataset.layerId = layer.id;
        wrapper.style.left = `${layer.x}px`;
        wrapper.style.top = `${layer.y}px`;
        wrapper.style.zIndex = String(layer.zIndex);
        if (selectedLayerId === layer.id) wrapper.classList.add("is-selected");

        if (layer.type === "text") {
          const textNode = document.createElement("div");
          textNode.className = "sticker-text-content";
          textNode.textContent = layer.text;
          textNode.style.color = layer.color || "#111111";
          textNode.style.fontSize = `${layer.fontSize || 34}px`;
          wrapper.appendChild(textNode);
        } else {
          const imgNode = document.createElement("img");
          imgNode.className = "sticker-img-content";
          imgNode.src = layer.src;
          imgNode.alt = "Uploaded element";
          imgNode.draggable = false;
          wrapper.style.width = `${layer.width || 180}px`;
          wrapper.style.height = `${layer.height || 180}px`;
          wrapper.appendChild(imgNode);
        }

        if (selectedLayerId === layer.id) {
          const handle = document.createElement("div");
          handle.className = "sticker-resize-handle";
          wrapper.appendChild(handle);
        }

        canvas.appendChild(wrapper);
      });
    };

    const rerender = () => {
      renderCanvas();
      renderLayerList();
      updateFormState();
    };

    const textSize = document.getElementById(`StickerTextSize-${sectionId}`);
    let lastSelectedColor = "#111111";

    const addTextLayer = () => {
      const text = sanitize(textInput.value.trim());
      if (!text) return;
      layers.push({
        id: uid(),
        type: "text",
        text,
        color: lastSelectedColor,
        fontSize: textSize ? parseInt(textSize.value, 10) : 34,
        x: 26,
        y: 26,
        zIndex: nextZ(),
      });
      textInput.value = "";
      rerender();
    };

    const updateSelectedTextLayer = () => {
      if (!selectedLayerId) return;
      const layer = layers.find((l) => l.id === selectedLayerId);
      if (layer && layer.type === "text") {
        layer.color = lastSelectedColor;
        if (textSize) layer.fontSize = parseInt(textSize.value, 10) || 34;
        rerender();
      }
    };

    if (textSize) textSize.addEventListener("input", updateSelectedTextLayer);

    const addImageLayer = (src, width = 180, height = 180) => {
      const aspect = (width || 180) / (height || 180);
      let initWidth = 180;
      let initHeight = 180 / aspect;
      if (initWidth > 260) { initWidth = 260; initHeight = 260 / aspect; }
      layers.push({
        id: uid(),
        type: "image",
        src,
        width: initWidth,
        height: initHeight,
        x: 24,
        y: 24,
        zIndex: nextZ(),
      });
      rerender();
    };

    const drag = { active: false, isResizing: false, id: null, offsetX: 0, offsetY: 0, startX: 0, startY: 0, startWidth: 0, startHeight: 0 };

    canvas.addEventListener("pointerdown", (e) => {
      closeAllColorPickers();
      if (e.target.classList.contains("sticker-resize-handle")) {
        e.stopPropagation();
        const target = e.target.closest(".sticker-canvas-item-wrapper");
        if (!target) return;
        const layer = layers.find((l) => l.id === target.dataset.layerId);
        if (!layer) return;
        drag.active = true;
        drag.id = layer.id;
        drag.isResizing = true;
        drag.startX = e.clientX;
        drag.startY = e.clientY;
        drag.startWidth = layer.type === "text" ? layer.fontSize || 34 : layer.width;
        drag.startHeight = layer.height;
        return;
      }
      const target = e.target.closest(".sticker-canvas-item-wrapper");
      if (!target) { selectedLayerId = null; rerender(); return; }
      const layer = layers.find((l) => l.id === target.dataset.layerId);
      if (!layer) return;
      selectedLayerId = layer.id;
      if (layer.type === "text") {
        lastSelectedColor = layer.color || "#000000";
        if (textSize) textSize.value = layer.fontSize || 34;
      }
      const rect = target.getBoundingClientRect();
      drag.active = true;
      drag.isResizing = false;
      drag.id = layer.id;
      drag.offsetX = e.clientX - rect.left;
      drag.offsetY = e.clientY - rect.top;
      rerender();
    });

    window.addEventListener("pointermove", (e) => {
      if (!drag.active || !drag.id) return;
      const layer = layers.find((l) => l.id === drag.id);
      if (!layer) return;
      const rect = canvas.getBoundingClientRect();
      if (drag.isResizing) {
        const dx = e.clientX - drag.startX;
        if (layer.type === "image") {
          const aspect = drag.startWidth / drag.startHeight;
          const newWidth = Math.max(20, drag.startWidth + dx);
          layer.width = newWidth;
          layer.height = newWidth / aspect;
        } else if (layer.type === "text") {
          layer.fontSize = Math.max(12, drag.startWidth + dx / 2);
        }
        renderCanvas();
        updateFormState();
        return;
      }
      layer.x = clamp(e.clientX - rect.left - drag.offsetX, 0, rect.width - (layer.width || 30));
      layer.y = clamp(e.clientY - rect.top - drag.offsetY, 0, rect.height - (layer.height || 30));
      renderCanvas();
      updateFormState();
    });

    window.addEventListener("pointerup", () => {
      drag.active = false;
      drag.isResizing = false;
      drag.id = null;
    });

    layerList.addEventListener("click", (e) => {
      const colorBtn = e.target.closest(".sticker-layer-color-btn");
      if (colorBtn) {
        const id = colorBtn.dataset.id;
        const layer = layers.find((l) => l.id === id);
        if (!layer) return;
        
        if (activeColorPickerLayerId === id) {
          closeAllColorPickers();
          return;
        }
        
        closeAllColorPickers();
        activeColorPickerLayerId = id;
        
        const popup = document.createElement("div");
        popup.className = "sticker-color-palette-popup";
        
        const rect = colorBtn.getBoundingClientRect();
        popup.style.top = `${rect.top - 10}px`;
        popup.style.left = `${rect.right + 10}px`;
        
        const colors = [
          "#0D0D0D",
          "#C9A84C",
          "#FAF8F3",
          "#2D4A2B",
          "#A84B2F",
          "#4A4A52",
          "#6E2F38",
          "#C9B68F"
        ];
        colors.forEach(c => {
          const swatch = document.createElement("div");
          swatch.className = "sticker-color-swatch";
          swatch.style.background = c;
          swatch.addEventListener("click", () => {
            layer.color = c;
            lastSelectedColor = c;
            closeAllColorPickers();
            rerender();
          });
          popup.appendChild(swatch);
        });

        colorBtn.parentElement.appendChild(popup);
        return;
      }

      const button = e.target.closest("button");
      if (!button) return;
      const id = button.dataset.id;
      const index = layers.findIndex((l) => l.id === id);
      if (index < 0) return;
      if (button.dataset.action === "delete") {
        layers.splice(index, 1);
        if (selectedLayerId === id) selectedLayerId = null;
      }
      rerender();
    });

    photoInput.addEventListener("change", async (e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;
      isUploading = true;
      updateFormState();
      for (const file of files) {
        const imageUrl = await processImage(file);
        await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => { addImageLayer(imageUrl, img.width, img.height); resolve(); };
          img.onerror = resolve;
          img.src = imageUrl;
        });
      }
      isUploading = false;
      photoInput.value = "";
      updateFormState();
    });

    textAdd.addEventListener("click", addTextLayer);
    textInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") { e.preventDefault(); addTextLayer(); }
    });

    if (textIdea) {
      textIdea.addEventListener("change", (e) => {
        if (e.target.value) {
          textInput.value = e.target.value;
        }
      });
    }

    window.addEventListener("resize", updateCanvasRatio);

    variantPicker.addEventListener("change", (e) => {
      const input = e.target.closest("input[type='checkbox']");
      if (!input) return;
      
      const card = input.closest(".sticker-option-card");
      if (input.checked) {
        card.classList.add("is-active");
      } else {
        card.classList.remove("is-active");
      }
      updateCanvasRatio();
      updateFormState();
    });

    const exportCanvasDataUrl = async (productTitle, forPrint = false) => {
      const cw = canvas.clientWidth || 800;
      const ch = canvas.clientHeight || 500;
      const vt = productTitle.toLowerCase();
      const isTag  = vt.includes("mirror") || vt.includes("tag");

      let bW, bH;
      if (forPrint) {
        if (isTag) { bW = 1050; bH = 1500; }
        else       { bW = 1200; bH = 1500; }
      } else {
        if (isTag) { bW = 420; bH = 600; }
        else       { bW = 400; bH = 500; }
      }

      const out = document.createElement("canvas");
      out.width = bW;
      out.height = bH;
      const fCtx = out.getContext("2d");

      // Render base layers at original size
      const tmpBase = document.createElement("canvas");
      tmpBase.width = cw;
      tmpBase.height = ch;
      const tbCtx = tmpBase.getContext("2d");

      sortByZ();
      for (const layer of layers) {
        if (layer.type === "text") {
          tbCtx.fillStyle = layer.color || "#111111";
          tbCtx.font = `700 ${layer.fontSize || 34}px Inter, Arial, sans-serif`;
          tbCtx.textBaseline = "top";
          tbCtx.fillText(layer.text, layer.x, layer.y);
        } else {
          await new Promise((resolve) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => { tbCtx.drawImage(img, layer.x, layer.y, layer.width || 180, layer.height || 180); resolve(); };
            img.onerror = resolve;
            img.src = layer.src;
          });
        }
      }

      // Draw tmpBase onto tmp mapped to final dimensions (bW x bH)
      const tmp = document.createElement("canvas");
      tmp.width = bW;
      tmp.height = bH;
      const tCtx = tmp.getContext("2d");

      const availW = bW * 0.88;
      const availH = bH * 0.88;
      const fitScale = Math.min(availW / cw, availH / ch);
      const fw = cw * fitScale;
      const fh = ch * fitScale;
      const fx = (bW - fw) / 2;
      const fy = (bH - fh) / 2 + (isTag ? bH * 0.05 : 0); // Shift down for tag hole

      tCtx.drawImage(tmpBase, fx, fy, fw, fh);

      if (isTag) {
        // Find bounding box to center the top hole
        const imgData = tCtx.getImageData(0, 0, bW, bH).data;
        let minX = bW, minY = bH, maxX = 0, maxY = 0;
        for (let y = 0; y < bH; y++) {
          for (let x = 0; x < bW; x++) {
            const alpha = imgData[(y * bW + x) * 4 + 3];
            if (alpha > 5) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (minX > maxX) { minX = bW/2 - 100; maxX = bW/2 + 100; minY = bH/2 - 100; maxY = bH/2 + 100; }
        const cX = (minX + maxX) / 2;

        // Silhouette for the white contour
        const sil = document.createElement("canvas");
        sil.width = bW; sil.height = bH;
        const sCtx = sil.getContext("2d");
        sCtx.drawImage(tmp, 0, 0);
        sCtx.globalCompositeOperation = "source-in";
        sCtx.fillStyle = "#FFFFFF";
        sCtx.fillRect(0, 0, bW, bH);

        // Base background (thick white stroke + top tab)
        const baseCanvas = document.createElement("canvas");
        baseCanvas.width = bW; baseCanvas.height = bH;
        const bCtx = baseCanvas.getContext("2d");

        const strokeWidth = bW * 0.035;
        for (let i = 0; i < 36; i++) {
          const angle = (i / 36) * Math.PI * 2;
          const dx = Math.cos(angle) * strokeWidth;
          const dy = Math.sin(angle) * strokeWidth;
          bCtx.drawImage(sil, dx, dy);
        }

        // Top tab
        const tabRadius = bW * 0.06;
        bCtx.globalCompositeOperation = "source-over";
        bCtx.fillStyle = "#FFFFFF";
        bCtx.beginPath();
        bCtx.arc(cX, minY - strokeWidth, tabRadius, 0, Math.PI * 2);
        bCtx.fill();

        // Top hole
        const holeRadius = tabRadius * 0.4;
        bCtx.globalCompositeOperation = "destination-out";
        bCtx.beginPath();
        bCtx.arc(cX, minY - strokeWidth, holeRadius, 0, Math.PI * 2);
        bCtx.fill();

        // Draw shadow and base layer
        fCtx.shadowColor = "rgba(0, 0, 0, 0.25)";
        fCtx.shadowBlur = bW * 0.04;
        fCtx.shadowOffsetY = bW * 0.02;
        fCtx.drawImage(baseCanvas, 0, 0);
        fCtx.shadowColor = "transparent";

        // Draw gold string through hole
        fCtx.beginPath();
        fCtx.moveTo(cX - bW * 0.02, 0);
        fCtx.lineTo(cX, minY - strokeWidth);
        fCtx.lineTo(cX + bW * 0.02, 0);
        fCtx.strokeStyle = "#C9A84C";
        fCtx.lineWidth = bW * 0.012;
        fCtx.stroke();

        // Draw actual design over top
        fCtx.drawImage(tmp, 0, 0);

      } else {
        // Standard poster rendering
        fCtx.fillStyle = "#FFFFFF";
        fCtx.shadowColor = "rgba(0, 0, 0, 0.1)";
        fCtx.shadowBlur = 10;
        fCtx.fillRect(10, 10, bW - 20, bH - 20);
        fCtx.shadowColor = "transparent";
        fCtx.beginPath();
        fCtx.rect(10, 10, bW - 20, bH - 20);
        fCtx.clip();
        fCtx.drawImage(tmp, 0, 0);
      }

      fCtx.save();
      fCtx.rotate(-25 * Math.PI / 180);
      fCtx.font = `700 ${Math.round(bW * 0.035)}px Inter, Arial, sans-serif`;
      fCtx.fillStyle = "rgba(0,0,0,0.06)";
      fCtx.textAlign = "center";
      const wStep = bW * 0.35;
      const hStep = bH * 0.10;
      for (let wx = -bW; wx < bW * 2; wx += wStep) {
        for (let wy = -bH; wy < bH * 2; wy += hStep) {
          fCtx.fillText("PEAK PURPOSE", wx, wy);
        }
      }
      fCtx.restore();

      return forPrint ? out.toDataURL("image/webp", 0.92) : out.toDataURL("image/png");
    };

    previewButton?.addEventListener("click", async () => {
      const checkedInputs = Array.from(variantPicker.querySelectorAll("input[type='checkbox']:checked"));
      if (!layers.length || !checkedInputs.length) { updateFormState(); return; }
      
      if (previewContainer) previewContainer.innerHTML = "";
      
      for (const input of checkedInputs) {
        const title = input.dataset.title;
        const dataUrl = await exportCanvasDataUrl(title);
        
        const wrapper = document.createElement("div");
        wrapper.className = "sticker-preview-item";
        
        const img = document.createElement("img");
        img.src = dataUrl;
        img.alt = title;
        
        const label = document.createElement("span");
        label.textContent = title;
        
        wrapper.appendChild(img);
        wrapper.appendChild(label);
        
        if (previewContainer) previewContainer.appendChild(wrapper);
      }
      
      if (typeof previewModal.showModal === "function") previewModal.showModal();
    });

    previewClose?.addEventListener("click", () => previewModal.close());

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const checkedInputs = Array.from(variantPicker.querySelectorAll("input[type='checkbox']:checked"));
      if (!layers.length || isUploading || !checkedInputs.length) { updateFormState(); return; }

      submitButton.disabled = true;
      const originalLabel = submitButton.textContent;
      submitButton.textContent = "Processing...";

      try {
        const items = [];
        let cartNotes = [];
        
        for (const input of checkedInputs) {
          const title = input.dataset.title;
          const titleLower = title.toLowerCase();
          let hardwareNote = "None";
          if (titleLower.includes("mirror") || titleLower.includes("tag")) hardwareNote = "include string/ribbon through punch hole";
          else if (titleLower.includes("small") || titleLower.includes("8x10")) hardwareNote = "include 2 x 3M Command strips";
          else if (titleLower.includes("medium") || titleLower.includes("11x14")) hardwareNote = "include 3 x 3M Command strips";
          else if (titleLower.includes("large") || titleLower.includes("16x20")) hardwareNote = "include 4 x 3M Command strips";

          cartNotes.push(`- ${title} — ${hardwareNote}`);

          // We'd ideally generate the print-ready preview per variant, but for speed, we will generate once for the first item and attach it.
          const previewDataUrl = await exportCanvasDataUrl(title, true);

          items.push({
            id: Number(input.value),
            quantity: 1,
            properties: {
              _sticker_preview_url: previewUrlInput?.value || "",
              _sticker_design_json_url: jsonUrlInput?.value || "",
              _sticker_layer_count: String(layers.length),
              _sticker_design_state: designStateInput.value || "",
              _hardware_included: hardwareNote,
              _design_preview: previewDataUrl.substring(0, 50) + "..." // In reality, we upload this to s3. This is just a placeholder.
            }
          });
        }

        const cartPayload = { 
          items,
          note: cartNotes.join("\n")
        };

        const add = await fetch(
          window.Shopify?.routes?.root ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(cartPayload),
          }
        );

        if (!add.ok) {
          let errMsg = "Failed to add item to cart";
          try {
            const errData = await add.json();
            errMsg = errData.description || errData.message || errMsg;
          } catch (_) {}
          throw new Error(errMsg);
        }

        window.location.href = "/checkout";

      } catch (err) {
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
        if (validation) {
          validation.hidden = false;
          validation.textContent = "Error: " + err.message;
        }
      }
    });

    // Ensure initialization
    updateCanvasRatio();
    rerender();
  });
})();